import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import FocusLock from 'react-focus-lock';
import { Backdrop, gray95, screenSmMax, screenXsMax, spacer16, spacer32, black, gray90, gray50, Popover, Type, KeyboardDetectionProvider, } from '@spotify-internal/encore-web';
import info from './info.json';
import { getDisplayName, getDisplayNameEn } from './utils';
const LanguageGrid = styled.div `
  display: grid;
  padding-top: ${spacer16};
  // 4 columns by default
  grid-template-columns: repeat(4, 1fr);
  // 2 columns for small screens
  @media (max-width: ${screenSmMax}) {
    grid-template-columns: repeat(2, 1fr);
  }
  // 1 column for the extra small screens
  @media (max-width: ${screenXsMax}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
const LanguageOption = styled.a `
  display: inline-flex;
  flex-direction: column;
  text-align: left;
  text-decoration: none;
  padding: ${spacer16};
  &,
  &:hover,
  &:focus {
    color: ${black};
    text-decoration: none;
    outline: none;
  }
  &:hover {
    background-color: ${gray95};
  }
  &:focus {
    background-color: ${gray90};
  }
`;
const TextContainer = styled.div `
  padding: 0 ${spacer16};
`;
const CustomBackdrop = styled(Backdrop) `
  overflow: auto;
`;
const Container = styled.div `
  max-height: 100%;
`;
const CustomPopover = styled(Popover) `
  margin: ${spacer32};
  width: calc(100vw - ${spacer32} - ${spacer32});
  max-width: 978px;
`;
const MutedText = styled.span `
  color: ${gray50};
`;
export function LanguageSelectionDialog({ currentLocale, getHref, getTranslation, onClose, onLanguageSelect, }) {
    const focusLangRef = useRef(null);
    useEffect(() => {
        var _a;
        (_a = focusLangRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    const ariaLabelledBy = 'language-selection-title';
    const ariaDescribedBy = 'language-selection-description';
    return (React.createElement(KeyboardDetectionProvider, null,
        React.createElement(FocusLock, { returnFocus: true },
            React.createElement(CustomBackdrop, { center: true, onClose: onClose },
                React.createElement(Container, null,
                    React.createElement("div", null,
                        React.createElement(CustomPopover, { popoverTitle: React.createElement(TextContainer, null,
                                React.createElement("span", { id: ariaLabelledBy }, getTranslation('LANGUAGE_MODAL_CHOOSE_A_LANGUAGE'))), onClose: onClose, role: "dialog", "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaLabelledBy },
                            React.createElement(TextContainer, null,
                                React.createElement(Type, { as: "p", id: ariaDescribedBy }, getTranslation('LANGUAGE_MODAL_DESCRIPTION'))),
                            React.createElement(LanguageGrid, null, Object.keys(info).map(locale => (React.createElement(LanguageOption, { key: locale, "data-testid": `language-option-${locale}`, href: getHref(locale), ref: locale === currentLocale ? focusLangRef : null, onClick: () => {
                                    onLanguageSelect(locale);
                                } },
                                getDisplayName(locale),
                                React.createElement(MutedText, null, getDisplayNameEn(locale)))))))))))));
}
//# sourceMappingURL=LanguageSelectionDialog.js.map